'use client';

import React, { useEffect, useState } from 'react';
import Input_Primary from '../Input_Primary/Input_Primary';
import { icons } from '@/Icons';
import ds from '@/styles/ds/ds.module.scss';
import { useUser } from '@/store';
import { countyCodeDialMapping } from '@/constants';

interface Input_PhoneNumberProps {
	phoneNumber: string;
	selectedDial: string;
	setSelectedDial: (dial: string) => void;
	setPhoneNumber: (phone: string) => void;
}

const Input_PhoneNumber = ({
	phoneNumber,
	setPhoneNumber,
	selectedDial,
	setSelectedDial,
}: Input_PhoneNumberProps) => {
	const user = useUser();

	useEffect(() => {
		if (user?.phoneCode) setSelectedDial(user.phoneCode);
		if (user?.phone) setPhoneNumber(user.phone);
	}, [user]);

	return (
		<div className="flex gap-2 items-end w-full h-full">
			<div
				className={`${ds.container_input} appearance-none focus:outline-none !px-0 max-w-[104px] h-10 justify-center flex gap-3.5 relative`}
			>
				<select
					name="phoneCode"
					value={selectedDial}
					onChange={(e) => setSelectedDial(e.target.value)}
					className={`bg-transparent border rounded pl-4 pr-8 h-10 ${ds.inputContainer} appearance-none
						${!selectedDial ? 'text-dove-white-o-40' : ''}
					`}
				>
					<option value="">+ Code</option>
					{countyCodeDialMapping.map((c) => (
						<option key={c.code} value={c.dial}>
							{c.code} {c.dial}
						</option>
					))}
				</select>
				<div className="absolute pointer-events-none right-4">
					<icons.dropdownarrow className="text-dove-white-o-70" />
				</div>
			</div>

			<Input_Primary
				inputProps={{
					id: 'phoneNumber',
					type: 'tel',
					name: 'phoneNumber',
					value: phoneNumber,
					onChange: (e) => setPhoneNumber(e.target.value),
					placeholder: 'Phone Number',
				}}
				label="Phone Number"
				labelProps={{
					htmlFor: 'phoneNumber',
				}}
			/>
		</div>
	);
};

export default Input_PhoneNumber;
